import { BaseModel } from './BaseModel';
import Category from './Category';

export class SubCategory extends BaseModel {
  static get entity() {
    return 'sub-categories';
  }

  static get fk() {
    return 'sub_categories_id';
  }

  static fields() {
    return {
      id: this.uid(),
      name: this.attr(null),
      created_at: this.attr(null),
      updated_at: this.attr(null),
      delete_at: this.attr(null),
      category_id: this.attr(null),
      category: this.belongsTo(Category, 'category_id')
    };
  }

  static apiConfig = {
    actions: {
      fetch() {
        return this.get(`/sub-categories`);
      },

      fetchByCategoryId(id) {
        return this.get(`/sub-categories/${id}`);
      }
    }
  };
}

export default SubCategory;
